/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-22 17:39:57
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-12 15:19:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/validation/index.ts
 */
import { convertSpecificError } from 'src/constrains/SalesChannelPreviewPageComponents/tools';

export const validation = (type: string, value: any) => {
  const errCode = [];
  if (type === 'text') {
    if (!value) errCode.push(999999);
  }
  if (type === 'image') {
    if (!value) errCode.push(999998);
  }
  return errCode;
};
export const errKey = {
  textErr: 'buttonTextTextError',
  contentTextErr: 'contentTextErr',
  contentImageErr: 'contentImageErr',
};

export const contentSettingValidation = (contentSetting, isPrimary) => {
  const { text, image } = contentSetting || {};

  const specificErr = {
    [errKey.contentTextErr]: [],
    [errKey.contentImageErr]: [],
  };
  if (!text) {
    specificErr[errKey.contentTextErr].push('Please input text');
  }
  if (!(image || {}).uuid) {
    specificErr[errKey.contentImageErr].push('Please upload image');
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
    errKey,
  };
};

export const buttonTextValidation = (buttonText, isPrimary) => {
  const { text } = buttonText || {};

  const specificErr = {
    [errKey.textErr]: [],
  };
  if (!text) {
    specificErr[errKey.textErr].push('Please input button text');
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
    errKey,
  };
};
